"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _index = _interopRequireDefault(require("./index.style"));
var _theme = _interopRequireDefault(require("../../theme"));
const Banner = _ref => {
  let {
    icon = '',
    color = '',
    title = ' ',
    description = ''
  } = _ref;
  const classes = (0, _index.default)();
  const isMobile = (0, _useMediaQuery.default)(_theme.default.breakpoints.down('sm'));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.banner
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.status,
    style: {
      backgroundColor: color
    }
  }, icon, ' ', isMobile ? /*#__PURE__*/_react.default.createElement("span", {
    className: classes.statusTitle
  }, title) : ''), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.body,
    style: {
      color
    }
  }, !isMobile ? /*#__PURE__*/_react.default.createElement("div", {
    className: classes.title
  }, title) : '', /*#__PURE__*/_react.default.createElement("div", {
    className: classes.content
    // eslint-disable-next-line react/no-danger
    ,
    dangerouslySetInnerHTML: {
      __html: description
    }
  })));
};
var _default = exports.default = Banner;